/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : PreviewModal.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  IconButton,
} from "@mui/material";
import CustomButtonV2 from "../../../components/customComponentsV2/common/button/CustomButtonV2";
import PreviewModalTemplate from "./previewModelTemplate";
import CloseIcon from "@mui/icons-material/Close";
import { componentStyle } from "../../../config/appTheme";

export default function PreviewModal({ isOpen, onClose, pages, title }) {

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xl">
      <DialogTitle
        sx={{
          position: "relative", // ✅ allows absolute positioning of close button
          p: 2,
          borderBottom: "none",
        }}
      >
        <Box sx={{ ...componentStyle.font.cardHeadder }}>
          {title ?? "Preview"}
        </Box>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
            position: "absolute", // ✅ detach from flex flow
            right: 2,
            top: 2,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <PreviewModalTemplate pages={pages} />
      </DialogContent>

      <DialogActions>
        <CustomButtonV2
          type="cancel"
          size="small"
          btnName="Close"
          handleOnClick={onClose}
        />
      </DialogActions>
    </Dialog>
  );
}

PreviewModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  pages: PropTypes.array,
  title: PropTypes.string,
};
